import * as React from 'react';
import {LineBreak} from '@openfin/desktop-ui';

import {Option} from './Divider';

interface Props {
    title: string;
    options?: Option[];
    className?: string;
}

export const Section: React.FC<Props> = (props) => {
    const {title, children, className} = props;

    return (
        <div className={className}>
            <LineBreak>{title}</LineBreak>
            {children}
        </div>
    );
};
